import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import type { AppDispatch } from '@nextgen-web-framework/core';
import { MLPVersion } from '@nextgen-web-framework/all';
import { Formik, Form } from 'formik';
import {
  verifyOtpWithChallengeIdSliceReq,
  updateOtpData,
  sendOtpWithChallengeIdSliceReq,
} from '@commerce-identity-webcomponents/sdk';
import { OtpVerificationProps, VerifyCodeFormInitialValue } from './types/propTypes';
import { OtpVerification as OtpVerificationMLPv1 } from './MLPv1/OtpVerification';
import { OtpVerification as OtpVerificationMLPv2 } from './MLPv2/OtpVerification';
import { OtpVerificationUserType } from './types/enums';

const OtpVerification = (props: OtpVerificationProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const { challengeId, callback, onClose, mlpVersion = MLPVersion.ONE } = props;
  const initialValues: VerifyCodeFormInitialValue = {
    otp: '',
  };

  useEffect(() => {
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    dispatch<any>(sendOtpWithChallengeIdSliceReq({ challengeId }));
  }, [dispatch, challengeId]);

  const submitHandler = async (values: VerifyCodeFormInitialValue) => {
    try {
      const { otp } = values;
      // eslint-disable-next-line  @typescript-eslint/no-explicit-any
      const { challengeVerified } = await dispatch<any>(
        verifyOtpWithChallengeIdSliceReq({ challengeId, code: otp }),
      ).unwrap();
      if (challengeVerified) {
        setTimeout(() => {
          callback?.();
          setTimeout(onClose, 0);
        }, 300);
      }
    } catch (error) {
      // eslint-disable-next-line  @typescript-eslint/no-explicit-any
      dispatch<any>(updateOtpData({ isVerified: false, isChecking: false, isInvalid: true }));
    }
  };

  const verifyForm = { initialValues, onSubmit: submitHandler };

  const fetchComponent = () => {
    switch (mlpVersion) {
      case MLPVersion.ONE:
        return <OtpVerificationMLPv1 {...props} />;
      case MLPVersion.TWO:
        return <OtpVerificationMLPv2 {...props} />;
      default:
        return <OtpVerificationMLPv1 {...props} />;
    }
  };

  return (
    <Formik {...verifyForm}>
      <Form data-testid="otp-verify-form-test-id">{fetchComponent()}</Form>
    </Formik>
  );
};

export default OtpVerification;
export { OtpVerificationUserType };
